var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"h-14 flex justify-center items-center arrow-box outline-none focus:outline-none",class:[
    _vm.type,
    {
      'h-14 w-14 bg-gray-400 bg-opacity-60 rounded-full':
        !_vm.isDesktop && _vm.type == 'base'
    }
  ],on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"arrow left",class:{ 'ml-1': !_vm.isDesktop }}),(_vm.text)?_c('span',{staticClass:"ml-4 font-semibold"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }